import {useState, useContext} from "react";
import { UserContext } from '../Context/UserContext';
import GameBar from "./GameBar";
import NotPremium from "./NotPremium";
import PitcherRatingsTable from "./PitcherRatingsTable";
import BatterIconLogo from "./BatterIconLogo";
import "../styles/pitcherRatingsTableContainer.css"
import FormattedDate from "./FormattedDate";
import RatingDropDown from "./RatingDropDown";
import {useIsMobile} from "../hooks/useIsMobile"
import MobilePitcherList from "./MobilePitcherList";

function PitcherRatings() {
    const {isActiveSub} = useContext(UserContext);
    const [ratingTimeframe, setRatingTimeframe] = useState(false) //false is default (last 3 seasons), true is current season only
    //console.log('ratingTimeFrame', ratingTimeframe)
    //console.log('state', state)
    const isMobile = useIsMobile(768)
    const [showFullTable, setShowFullTable] = useState(false)
    const [showFullTablePrompt, setShowFullTablePrompt] = useState(true)

    function handleChange() {
        setRatingTimeframe(prevTimeframe => !prevTimeframe)
    }

    return (
        <div>
            {!isActiveSub && (
                <div className="userNotPremium">
                    <NotPremium />
                </div>
            )}
            {isActiveSub && (
                <div>
                    <BatterIconLogo logoID={"pitcherRatingsBatterIconLogo"} />
                    <h2 className="pitcherRatingsHeader">MLB Pitcher Ratings for {<FormattedDate />}</h2>
                    <GameBar />
                    <RatingDropDown ratingTimeframe={ratingTimeframe} handleChange={handleChange}/>
                    {isMobile ? (
                        <div>
                            <div className="mobileContainer">
                            {!showFullTablePrompt && ( <h3 className="changeViewHeader">Change View</h3>)}
                                <div className="promptBtnContainer">
                                    <button onClick={() => setShowFullTablePrompt(prev => !prev)}>{showFullTablePrompt ? "-" : "+"}</button>
                                </div>
                                {showFullTablePrompt && (
                                    <div className="promptHeaderContainer">
                                        <h2>{showFullTable ? "Go Back to Mobile List" : "Prefer the full table?"}</h2>
                                        <button onClick={() => setShowFullTable(prev => !prev)}>{showFullTable ? "View Mobile List" : "Show Full Table"}</button>
                                    </div>
                                )}
                            </div>
                            {showFullTable ? (
                                <PitcherRatingsTable ratingTimeframe={ratingTimeframe}/>
                            ) : (
                                <MobilePitcherList ratingTimeframe={ratingTimeframe}/> 
                            )}
                        </div>
                    ) : (
                        <PitcherRatingsTable ratingTimeframe={ratingTimeframe}/>
                    )}
                    {/* {isMobile ? (
                        <MobilePitcherList /> 
                    ) : (
                        <PitcherRatingsTable ratingTimeframe={ratingTimeframe}/>
                    )} */}
                </div>
            )}
        </div>
    )
}

export default PitcherRatings